import { render, staticRenderFns } from "./water-order-list.vue?vue&type=template&id=038381ec&scoped=true&"
import script from "./water-order-list.vue?vue&type=script&lang=js&"
export * from "./water-order-list.vue?vue&type=script&lang=js&"
import style0 from "./water-order-list.vue?vue&type=style&index=0&id=038381ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038381ec",
  null
  
)

export default component.exports